import { CART_ITEM_STATES } from '../../helpers/CartHelper';
import { ProductSerializer } from './ProductSerializer';

class CartItemSerializer {
  static deSerialize(data) {
    return {
      amount: data.CLiCantidad,
      product: ProductSerializer.deSerialize(data.Articulos),
      serviceAmount: data.CLiCantidadInstalaciones || 0,
      state: data.Estado || CART_ITEM_STATES.NO_ISSUES,
    };
  }
}

export { CartItemSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/CartItemSerializer.js